import { EDIT_ANNOTATION_POPOVER_Z_INDEX } from '../annotation-timeline-v2/constants';
export const POPOVER_OVERRIDES = {
  Body: {
    style: ({
      $theme: {
        colors,
        sizing
      }
    }) => ({
      width: '250px',
      padding: sizing.scale500,
      backgroundColor: colors.primaryB,
      margin: `${sizing.scale400} ${sizing.scale400} ${sizing.scale200} ${sizing.scale400}`,
      zIndex: EDIT_ANNOTATION_POPOVER_Z_INDEX
    })
  },
  Arrow: {
    style: ({
      $theme: {
        colors
      }
    }) => ({
      backgroundColor: colors.primaryB,
      boxShadow: 'none'
    })
  }
};